/**
 * For creating adaptive <picture><img ></picture>
 */
import { makePictureTree as filestackMakeTree } from 'filestack-adaptive'

export const imageComingSoon = 'GmSV395qTKCo08SAQjgA'
export const fileComingSoon = '0u6yO9ZGQLOyzbq8nSpN'

interface MakePictureTreePayload {
  alt?: string
  width?: string // with unit
  handle?: string | null
  comingSoon?: 'image' | 'file'
}

export function makePictureTree(payload: MakePictureTreePayload): any {
  const {
    alt = 'Daughtridge Sales',
    width = '400px',
    handle = null,
    comingSoon = 'image' // 'file'
  } = payload

  const placeholder = comingSoon === 'image' ? imageComingSoon : fileComingSoon

  return filestackMakeTree(handle || placeholder, {
    alt,
    transforms: {
      output: {
        format: 'jpg'
      }
    },
    width,
    security: {
      policy: import.meta.env.VITE_FILESTACK_CDN_RESIZE_POLICY,
      signature: import.meta.env.VITE_FILESTACK_CDN_RESIZE_SIGNATURE
    }
  })
}
